// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttonCloseHeader {
  padding: 20px;
  padding-bottom: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/core/controls/button-close/button-close.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;AACJ","sourcesContent":[".buttonCloseHeader {\r\n    padding: 20px;\r\n    padding-bottom: 0px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
